// extracted by mini-css-extract-plugin
export default {"root":"Label_root__TwTGr","optional":"Label_optional__CAQP-","main":"Label_main__R-CeS","disabled":"Label_disabled__SOj60"};